<template>
  <div v-if="event.title">
    <div class="text-xs-center pb-3">
      <img :src="imageUrl" alt="Logo" style="max-height: 300px">
    </div>
    <v-layout align-center justify-center wrap class="mb-4">
      <v-flex xs12 sm8>
        <h2>{{event.title}}</h2>
        <p>{{event.description}}</p>
        Veranstaltungsdatum: {{event.date | stringToDate}}<br/>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="my-4" v-if="eventGuests.length > 0">
      <v-flex xs12 sm8>
        <h2>Angemeldete Teilnehmer:</h2>
        <v-list class="nobg">
          <v-list-tile @click="" v-for="(guest, key) in (eventGuests)" :key="key"
                       :class="{ 'attending': guest.status === 70, 'denied': guest.status === 99 }">
            <v-list-tile-content>
              <v-list-tile-title>
                {{getGuestEmail(guest)}} - {{guest.status | eventGuestState}}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <dlg-confirm-delete title="Gast ausladen" @true="removeGuest(guest.guestId)" @false="" icon="cancel">
                Möchten Sie den Gast <strong>{{getGuestEmail(guest)}}</strong> wirklich ausladen?
              </dlg-confirm-delete>
              <!--<delete-confirm title="Gast ausladen" @yes="removeGuest(guest.guestId)" @no="" icon="cancel">-->
              <!--Möchten Sie den Gast <strong>{{getGuestEmail(guest)}}</strong> wirklich ausladen?-->
              <!--</delete-confirm>-->
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-if="uninvitedGuests.length > 0">
      <v-flex xs12 sm8>
        <h3>Ehemaligen Gast einladen</h3>
        <v-card>
          <v-card-text>
            <v-select
              prepend-icon="email"
              :items="uninvitedGuests"
              item-text="email"
              item-value="id"
              multiple
              v-model="newGuests"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="primary" @click="saveGuests" :loading="loading">Hinzufügen</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4">
      <v-flex xs12 sm8>
        <h3>Neuen Gast einladen</h3>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs6>
                  <v-select
                    :items="genders"
                    v-model="newGuest.gender"
                    label="Anrede"
                    single-line
                    :disabled="loading"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Titel"
                    v-model="newGuest.title"
                    :disabled="loading"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Vorname"
                    v-model="newGuest.forename"
                    :disabled="loading"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Nachname"
                    v-model="newGuest.surname"
                    :disabled="loading"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Email"
                    required
                    :rules="emailRules"
                    v-model="newGuest.email"
                    :disabled="loading"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!valid"
                color="primary"
                @click="createGuest"
                :loading="loading"
              >
                Person einladen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {Storage} from 'aws-amplify';
  import {mapGetters, mapActions} from 'vuex';
  import DlgConfirmDelete from '@/components/Dialogs/DlgConfirmDelete.vue';

  export default {
    components: {DlgConfirmDelete},
    props: ['eventId', 'hostId'],
    data() {
      return {
        newGuest: {},
        newGuests: [],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
        valid: true,
        emailRules: [
          (v) => !!v || 'E-mail ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
        imageUrl: '',
      };
    },
    computed: {
      ...mapGetters({
        event: 'pub/host/event',
        host: 'pub/host/host',
        savedGuests: 'pub/host/savedGuests',
        eventGuests: 'pub/host/eventGuests',
        loading: 'common/loader/loading',
      }),
      uninvitedGuests() {
        return this.savedGuests.filter((savedGuest) => (
          this.eventGuests.filter((el) => el.guestId === savedGuest.id).length === 0));
      },
    },
    methods: {
      ...mapActions({
        storeReadEvent: 'pub/host/read',
        startLoader: 'common/loader/start',
        stopLoader: 'common/loader/stop',
        storeCreateGuest: 'pub/host/createGuest',
        storeRemoveGuest: 'pub/host/removeGuest',
        storeAddGuests: 'pub/host/addGuests',
      }),
      saveGuests() {
        this.startLoader();
        this.storeAddGuests({hostId: this.hostId, eventId: this.eventId, guests: this.newGuests}).then(() => {
          this.newGuests = [];
          this.stopLoader();
          this.readEvent();
        }).catch(() => {
          this.stopLoader();
        });
      },
      createGuest() {
        this.startLoader();
        this.storeCreateGuest({hostId: this.hostId, eventId: this.eventId, guest: this.newGuest}).then(() => {
          this.newGuest = {};
          this.stopLoader();
          this.readEvent();
        }).catch(() => {
          this.stopLoader();
        });
      },
      removeGuest(guestId) {
        this.startLoader();
        this.storeRemoveGuest({hostId: this.hostId, eventId: this.eventId, guestId}).then(() => {
          this.stopLoader();
          this.readEvent();
        }).catch(() => {
          this.stopLoader();
        });
      },
      getGuestEmail(eventGuest) {
        const guest = this.savedGuests.find((savedGuest) => savedGuest.id === eventGuest.guestId);
        if (guest) {
          return guest.email;
        }

        return '';
      },
      async readEvent() {
        this.startLoader();
        await this.storeReadEvent({hostId: this.hostId, eventId: this.eventId});
        this.stopLoader();
      },
    },
    async mounted() {
      await this.readEvent();
      this.imageUrl = await Storage.get(this.event.logo);
    },
  };
</script>

<style scoped>
  .attending {
    background-color: rgba(40, 254, 0, 0.15);
  }

  .denied {
    background-color: rgba(255, 0, 0, 0.15);
  }
</style>
